import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import DeleteButton from './DeleteButton';
import ShareButton from './ShareButton';
import TagsEditButton from './TagsEditButton';
import AiButton from './AiButton';
import ExportButton from './ExportButton';
import ItemCounterBar from '../ItemCounterBar';
const BulkActions = ({ selectedProjects, isOpenTeam, onRefetch, onRefetchTags, refreshProjects, onDeselect, }) => {
    const selectionEmpty = useMemo(() => selectedProjects.length === 0, [selectedProjects]);
    return (_jsxs(_Fragment, { children: [_jsx(DeleteButton, { selectedProjects: selectedProjects, isOpenTeam: isOpenTeam, selectionEmpty: selectionEmpty, onComplete: () => {
                    refreshProjects(false);
                    onDeselect();
                } }), _jsx(ShareButton, { selectedProjects: selectedProjects, selectionEmpty: selectionEmpty, onSharingUpdated: () => {
                    refreshProjects(false);
                    onDeselect();
                } }), _jsx(TagsEditButton, { selectionEmpty: selectionEmpty, selectedProjects: selectedProjects, onRefetch: onRefetch, onComplete: () => {
                    onRefetchTags();
                    refreshProjects(false);
                    onDeselect();
                } }), _jsx(AiButton, { selectionEmpty: selectionEmpty, selectedProjects: selectedProjects }), _jsx(ExportButton, { selectionEmpty: selectionEmpty, selectedProjects: selectedProjects, onComplete: onDeselect }), !selectionEmpty && (_jsx(ItemCounterBar, { itemCount: selectedProjects.length, onClear: onDeselect, itemType: "selected" }))] }));
};
export default BulkActions;
